import { render } from "./HistoryStock.vue?vue&type=template&id=6f33d592"
import script from "./HistoryStock.vue?vue&type=script&lang=js"
export * from "./HistoryStock.vue?vue&type=script&lang=js"

import "./HistoryStock.vue?vue&type=style&index=0&id=6f33d592&lang=css"

import exportComponent from "D:\\Programming\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__